import { render, staticRenderFns } from "./TostaoForm.vue?vue&type=template&id=00ba77c0"
import script from "./TostaoForm.vue?vue&type=script&lang=js"
export * from "./TostaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00ba77c0')) {
      api.createRecord('00ba77c0', component.options)
    } else {
      api.reload('00ba77c0', component.options)
    }
    module.hot.accept("./TostaoForm.vue?vue&type=template&id=00ba77c0", function () {
      api.rerender('00ba77c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/alianzas/integrations/TostaoForm.vue"
export default component.exports